import React, { useState } from "react";
import { useApi } from "../../hooks/useApi";
import { useAuth } from "../../context/AuthContext";
import {
  Card,
  Spinner,
  ErrorBox,
  SimpleTable,
} from "../../components/ui/basics";
import CrudModal from "../../components/normative/CrudModal";
import { TIPO } from "../../constants/normativeTipo";

export default function TipologieMansioneBlock() {
  const { apiRequest } = useAuth();
  const { data, loading, error, reload } = useApi(
    "/normative/tipologie-mansione",
  );
  const [modal, setModal] = useState(null);

  const fields = [
    {
      key: "codice",
      label: "Codice",
      required: true,
      disabled: modal?.mode === "edit",
    },
    { key: "name", label: "Nome", required: true },
  ];

  const submit = async (values) => {
    const payload = { ...values, tipo: TIPO.TIPOLOGIA_MANSIONE };
    if (modal.mode === "create") {
      await apiRequest("/normative/anagrafiche", {
        method: "POST",
        body: JSON.stringify(payload),
      });
    } else {
      await apiRequest(`/normative/anagrafiche/${modal.record.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
    }
    reload();
  };

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare la tipologia "${r.name}"?`)) return;
    await apiRequest(`/normative/anagrafiche/${r.id}`, { method: "DELETE" });
    reload();
  };

  return (
    <Card
      title="Tipologie mansione"
      actions={
        <button
          onClick={() => setModal({ mode: "create" })}
          className="text-sm bg-primary-600 text-white px-3 py-1.5 rounded hover:bg-primary-700"
        >
          + Nuova
        </button>
      }
    >
      {loading && <Spinner />}
      {error && <ErrorBox message={error} onRetry={reload} />}
      {data && (
        <SimpleTable
          rowKey={(r) => r.id}
          columns={[
            { key: "codice", label: "Codice" },
            { key: "name", label: "Nome" },
            {
              key: "azioni",
              label: "",
              render: (r) => (
                <div className="flex gap-2 justify-end">
                  <button
                    onClick={() => setModal({ mode: "edit", record: r })}
                    className="text-xs text-primary-600 hover:underline"
                  >
                    Modifica
                  </button>
                  <button
                    onClick={() => elimina(r)}
                    className="text-xs text-red-600 hover:underline"
                  >
                    Elimina
                  </button>
                </div>
              ),
            },
          ]}
          rows={data}
        />
      )}
      {modal && (
        <CrudModal
          title={
            modal.mode === "create"
              ? "Nuova tipologia"
              : `Modifica ${modal.record.name}`
          }
          fields={fields}
          initialValues={modal.record || {}}
          onSubmit={submit}
          onClose={() => setModal(null)}
        />
      )}
    </Card>
  );
}
